module.exports = "pegasus/assets/blocks/column-16-tech.png";